import React from "react";

const BonusSection = ({
  multiplePointsEarned,
  earnedPoints,
  review,
  orderCompletedRewardPoints
}) => (
  <div className="white-bg mt-10px padding-box points">
    {(multiplePointsEarned && (
      <React.Fragment>
        <p>Local E eCoins</p>
        <ul>
          <li className="d-flex justify-content-between">
            <p>Earned</p>
            <p className="bold">+{earnedPoints} eCoins.</p>
          </li>
          {(review.pointsEarned && (
            <li className="d-flex justify-content-between">
              <p>Review Bonus</p>
              <p className="bold">+{review.pointsEarned} eCoins.</p>
            </li>
          )) || <noscript />}
          {(orderCompletedRewardPoints && (
            <li className="d-flex justify-content-between">
              <p>Collection Bonus</p>
              <p className="bold">+{orderCompletedRewardPoints} eCoins.</p>
            </li>
          )) || <noscript />}
        </ul>
      </React.Fragment>
    )) || (
      <ul>
        <li className="d-flex justify-content-between">
          <p>Local E eCoins earned</p>
          <p className="bold">+{earnedPoints} eCoins.</p>
        </li>
      </ul>
    )}
  </div>
);

export default BonusSection;
